import { noticeDocuments } from '../../utils/tenderDocuments';

/* Fin d'un import ou d'une analyse : libère l'indicateur, puis efface le texte et la barre
   d'avancement après un court délai (le temps de lire « Analyse terminée »). */
export function endUpload({
  setTenderUploadBusy,
  setTenderUploadIdweb,
  setTenderUploadProgress,
  setTenderUploadStepText,
}) {
  setTenderUploadBusy(false);
  setTenderUploadIdweb(null);
  setTimeout(() => {
    setTenderUploadStepText('');
    setTenderUploadProgress(null);
  }, 1200);
}

// Applique une modification aux documents d'un avis, dans la fenêtre ouverte et dans la liste.
export function updateNoticeDocuments({ setModalData, setTenders }, idweb, change) {
  const apply = (notice) => ({ ...notice, boamp_documents: change(noticeDocuments(notice)) });
  setModalData((d) => (d.notice ? { ...d, notice: apply(d.notice) } : d));
  setTenders((list) => list.map((n) => (n.idweb === idweb ? apply(n) : n)));
}
